import axios from '../../axios'

/*
 * 报名订单数据接口
 */

// 获取报名订单列表
export const getOrderList = (data) => {
    return axios({
        url: '/api/mock/app/order',
        method: 'get',
        data
    })
}

// 删除报考记录
export const deleteOrderList = (data) => {
    return axios({
        url: '/api/mock/app/order',
        method: 'delete',
        data
    })
}

// 获取志愿服务订单列表
export const getWishOrderList = (data) => {
    return axios({
        url: '/api/data/wish/service_order',
        method: 'post',
        data
    })
}

// 退款
export const applRrefund = (data) => {
    return axios({
        url: '/api/pay/apply_refund',
        method: 'post',
        data
    })
}

export const exportOrder = (data) => {
    return axios({
        url: '/api/mock/app/export_order',
        method: 'get',
        data
    })
}

// 订单管理导出订单
export const exportBuyedOrder = (data) => {
    return axios({
        url: '/api/data/wish/export/service_order',
        method: 'post',
        data
    })
}

// 获取留学订单列表
export const getAbroadOrderList = (data) => {
    return axios({
        url: '/api/data/wish/abroad/order/page',
        method: 'post',
        data
    })
}

// 留学订单导出订单
export const exportAbroadOrder = (data) => {
    return axios(
        {
            url: '/api/data/wish/export/abroad/order',
            method: 'post',
            data
        }
    )
}

// 学生订单 文件批量删除
export const fileBatchDelStudent = (data) => {
    return axios({
        url: '/api/mock/app/delete/file/batch/order',
        method: 'POST',
        data
    })
}

// 保存备注
export const saveRemark = (data) => {
    return axios({
        url: '/api/data/wish/service/order',
        method: 'PUT',
        data
    })
}

// 订单管理导出结算订单
export const exportChannelOrder = (data) => {
    return axios({
        url: '/api/data/wish/parent/channel/service/order/export',
        method: 'post',
        data
    })
}

// 新增结算单
export const addSettleOrder = (data) => {
    return axios({
        url: '/api/data/wish/partners/settle',
        method: 'post',
        data
    })
}

// 查询结算单
export const getSettleOrder = (data) => {
    return axios({
        url: '/api/data/wish/partners/settle',
        method: 'get',
        data
    })
}

// 更新结算单
export const updateSettleOrder = (data) => {
    return axios({
        url: '/api/data/wish/partners/settle',
        method: 'put',
        data
    })
}

// 删除结算单
export const deleteSettleOrder = (data) => {
    return axios({
        url: '/api/data/wish/partners/settle',
        method: 'delete',
        data
    })
}

// 获取志愿服务订单列表
export const changeOrderChannel = (data) => {
    return axios({
        url: '/api/data/wish/service/order/channel',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/order.js